import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad8b2b02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 1,
  style: {"padding-left":"10px"}
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    name: {},
    icon: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_e_typography = _resolveComponent("e-typography")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.icon)
      ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          src: props.icon,
          class: "top-avatar"
        }, null, 8, ["src"]))
      : (_openBlock(), _createElementBlock("span", _hoisted_2)),
    _createVNode(_component_e_typography, {
      heading: "1",
      class: "white-color"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(props.name), 1)
      ]),
      _: 1
    })
  ]))
}
}

})